import React from "react";

export const Host = () => {
  return <h2>Host</h2>;
};
